import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { mainStoreWithoutHook } from '@/stores';
import env from '@/utils/env';
import pkg from '../../package.json';

UBT.config({
  env: process.env.REACT_APP_ENV,
  debug: process.env.REACT_APP_ENV !== 'pro',
  categoryId: 'evbike',
  history: false,
});

// UBT.bindData({
//   appVersion: pkg.version,
//   appName: 'AppEvBikeMiniProH5',
//   userGuid: () => mainStoreWithoutHook.userInfo?.guid,
//   // cityCode: () => window.$userInfoConfig.position.cityCode,
//   // cityName: () => window.$userInfoConfig.position.cityName,
//   // adCode: () => window.$userInfoConfig.position.adCode,
//   // longitude: () => window.$userInfoConfig.position.lng,
//   // latitude: () => window.$userInfoConfig.position.lat,
// });

const ubtParams = {
  appVersion: pkg.version,
  appName: 'AppEvBikeMiniProH5',
  userGuid: () =>
    mainStoreWithoutHook.userInfo?.guid ||
    mainStoreWithoutHook.userInfo?.userGuid,
};
UBT.bindData(ubtParams);
mainStoreWithoutHook
  ?.getUserInfo?.()
  ?.then(() => {
    const { guid, userGuid } = mainStoreWithoutHook?.userInfo || {};
    if (guid || userGuid) {
      UBT.bindData({ ...ubtParams, userGuid: guid || userGuid });
    }
  })
  .catch(() => null);

export default UBT;
